import { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';

import { UnifiedMitigationContentEditor } from '../../../../../components/inputs/UnifiedMitigationsContentEditor/UnifiedMitigationsContentEditor';
import { UnifiedMitigation } from '../../../../../types';

interface UnifiedMitigationDialogProps {
  open: boolean;
  onClose: () => void;
  mitigation: UnifiedMitigation | null;
}

const UnifiedMitigationDialog: FC<UnifiedMitigationDialogProps> = ({ open, onClose, mitigation }) => {
  if (!mitigation) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Mitigation Details</DialogTitle>
      <DialogContent dividers>
        <Box>
          <Typography variant="h6">{mitigation.name}</Typography>
          <Typography variant="subtitle1">Type: {mitigation.unifiedmitigationtype}</Typography>
          <UnifiedMitigationContentEditor
            value={mitigation.content}
            type={mitigation.unifiedmitigationtype}
            readonly={true}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnifiedMitigationDialog;
